var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { BetBtnOdd } from "./BetBtnOdd";
import { BetBtnMlQa } from "./BetBtnMlQa";
import { BetBtnOuHc } from "./BetBtnOuHc";
// TODO: TYPE UP THE ADD TO BET SLIP FUNCTIONS
export var BetBtnTypes;
(function (BetBtnTypes) {
    BetBtnTypes["Odd"] = "bet_btn--Odd";
    BetBtnTypes["ML"] = "bet_btn--ML";
    BetBtnTypes["QA"] = "bet_btn--QA";
    BetBtnTypes["OU"] = "bet_btn--OU";
    BetBtnTypes["HC"] = "bet_btn--HC";
})(BetBtnTypes || (BetBtnTypes = {}));
var BetBtnsMap = (_a = {},
    _a[BetBtnTypes.Odd] = function (props) { return (React.createElement(BetBtnOdd, { odd: props.odd })); },
    _a[BetBtnTypes.ML] = function (props) { return (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd })); },
    _a[BetBtnTypes.QA] = function (props) { return (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd })); },
    _a[BetBtnTypes.OU] = function (props) { return (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd })); },
    _a[BetBtnTypes.HC] = function (props) { return (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd })); },
    _a);
var BetBtn = /** @class */ (function (_super) {
    __extends(BetBtn, _super);
    function BetBtn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetBtn.prototype.noop = function () { return false; };
    BetBtn.prototype.fnRouter = function (handler) {
        return (typeof handler !== "function" ? this.noop : handler)();
    };
    BetBtn.prototype.render = function () {
        var cls = "bet_btn" + (this.props.modifier ? " " + this.props.modifier : "");
        return (React.createElement("button", { type: this.props.type, className: cls, onClick: this.fnRouter.bind(this, this.props.handler), disabled: this.props.isDisabled }, BetBtnsMap[this.props.type || BetBtnTypes.Odd](this.props)));
    };
    return BetBtn;
}(React.Component));
export { BetBtn };
var _a;
//# sourceMappingURL=BetBtn.js.map